import { defineMessages } from 'react-intl'

export default defineMessages({
  successTitle: {
    id: 'purchasing.assignDepartmentsToUser.presenter.successTitle',
    defaultMessage: 'Success',
  },
  successMessage: {
    id: 'purchasing.assignDepartmentsToUser.presenter.successMessage',
    defaultMessage: 'Permissions have been updated.',
  },
  errorTitle: {
    id: 'purchasing.assignDepartmentsToUser.presenter.errorTitle',
    defaultMessage: 'Error',
  },
  errorMessage: {
    id: 'purchasing.assignDepartmentsToUser.presenter.errorMessage',
    defaultMessage: 'Something went wrong. Please try again.',
  },
})
